import {
  Col,
  Container,
  Dropdown,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { useEffect, useMemo, useState } from "react";
import { ReactComponent as AGSearchIcon } from "../../assets/images/AGSearchIcon.svg";
import { ReactComponent as SearchXIcon } from "../../assets/images/SearchXIcon.svg";
import { ReactComponent as Download } from "../../assets/images/download-icon.svg";
import { ReactComponent as Share } from "../../assets/images/sharedocument.svg";
import { reportPlaceholder } from "../../constants/firm/labels";
import AgGrid from "../table/AgGrid";
import { useGetFADocCapacityUsageReportDetailsQuery } from "../../slices/reportApiManagementSlice";
import Loader from "../Loader/Loader";
import { useDownloadFirmAdminDocandCapacityDetailsReportMutation } from "../../slices/reportApiManagementSlice";
import { toast } from "react-toastify";
import { reportsPlaceholder } from "../../constants/firmdmin/labels";
import { ReactComponent as CheckIcon } from "../../assets/images/CheckIcon.svg";
import { ReactComponent as CloseIcon } from "../../assets/images/CloseIcon.svg";
import ShareReportModalPopup from "../modal/ShareReportModalPopup";
import { useSelector } from "react-redux";

export default function DownloadAndCapacityReport(selectedDocs) {
  const [searchText, setSearchText] = useState("");
  const [rowData, setRowData] = useState([]);
  const [greaterThan90Percent, setGreaterThan90Percent] = useState(0);
  const [docPerUser, setDocPerUser] = useState(0);
  const [willsUploaded, setWillsUploaded] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [fileName, setFileName] = useState("");
  const { userInfo } = useSelector((state) => state.auth);

  let empnameWidth = 200;
  let empnameMinWidth = 200;

  if (window.innerWidth < 576) {
    empnameWidth = 100;
    empnameMinWidth = 140;
  }

  const firmId = userInfo?.firmId;

  const { data, isLoading } = useGetFADocCapacityUsageReportDetailsQuery(
    firmId,
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (data) {
      let count = 0;
      let averageNumberOfDocs = 0;
      for (let i = 0; i < data?.length; i++) {
        count = count + data[i]?.numberOfdocs;
        averageNumberOfDocs = count / data.length;
      }
      setDocPerUser(Math.ceil(averageNumberOfDocs));
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      let count = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.willUploaded === "YES") {
          count++;
        }
      }
      const percentage = (count / data.length) * 100;
      setWillsUploaded(Math.ceil(percentage));
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      let count = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.capacityConsumption > 90) {
          count++;
        }
      }
      const percentage = (count / data.length) * 100;
      setGreaterThan90Percent(Math.ceil(percentage));
    }
  }, [data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };
  const handleClearSearch = () => {
    setSearchText("");
  };
  const GridFirmName = (params) => {
    const { value } = params;
    const firmName = value.length > 20 ? value.substring(0, 20) + "..." : value;

    return (
      <>
        {value.length > 20 ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-${value}`}>{value}</Tooltip>}
          >
            <div className="truncate-tooltip grid-firm-email-anchor">
              {firmName}
            </div>
          </OverlayTrigger>
        ) : (
          <div className="truncate-tooltip grid-firm-email-anchor">
            {firmName}
          </div>
        )}
      </>
    );
  };

  const CenterAligned = (p) => {
    return <div className="grid-center-aligned-text">{`${p.value}`}</div>;
  };

  const getRowStyle = () => {
    return { borderBottom: "unset" };
  };

  const CheckCloseIcon = ({ value }) => {
    return (
      <div className="grid-center-aligned-text">
        {value === "YES" ? <CheckIcon /> : <CloseIcon />}
      </div>
    );
  };

  const [columnDefs] = useState([
    {
      headerName: reportsPlaceholder.userName,
      field: "name",
      width: empnameWidth,
      minWidth: empnameMinWidth,
      sortable: true,
      unSortIcon: true,
      pinned: "left",
      cellRenderer: GridFirmName,
    },
    {
      headerName: reportsPlaceholder.capacityConsump,
      minWidth: 150,
      field: "capacityConsumption",
      cellRenderer: CenterAligned,
      headerClass: "center-aligned-header",
    },
    {
      headerName: reportsPlaceholder.noOfDocs,
      minWidth: 150,
      field: "numberOfdocs",
      cellRenderer: CenterAligned,
      headerClass: "center-aligned-header",
    },
    {
      headerName: reportsPlaceholder.willsUploaded,
      minWidth: 150,
      field: "willUploaded",
      cellRenderer: CheckCloseIcon,
      headerClass: "center-aligned-header",
    },
  ]);
  const headerRow = [
    {
      name: reportsPlaceholder.userName,
      capacityConsumption: reportsPlaceholder.capacityConsump,
      numberOfdocs: reportsPlaceholder.noOfDocs,
      willUploaded: reportsPlaceholder.willsUploaded,
    }
  ]
  useEffect(() => {
    if (data) {
      setRowData(data);
    }
  }, [data]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      suppressMovable: false,
      sortable: false,
      wrapHeaderText: true,
      wrapText: true,
      headerClass: "custom-header",
      resizable: false,
      lockPosition: true,
      filter: false,
      minWidth: 150,
    };
  }, []);

  const paginationSizeLimit = 10;

  useEffect(() => {
    if (data) {
      const formattedData = data.map((item) => ({
        ...item,
        capacityConsumption: `${item.capacityConsumption || 0}%`,
      }));
      setRowData(formattedData);
    }
  }, [data]);

  const customFilter = useMemo(() => {
    if (!searchText) return rowData;

    const searchTextLower = searchText.toLowerCase();

    return rowData.filter((item) => {
      return (
        item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.capacityConsumption.toLowerCase().includes(searchTextLower) ||
        item.numberOfdocs
          ?.toString()
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );
    });
  }, [searchText, rowData]);

  const [triggerDownload, { isLoading: download }] =
    useDownloadFirmAdminDocandCapacityDetailsReportMutation();

  const handleShare = () => {
    setShowModal(true);
  };

  useEffect(() => {
    const fileName = `Document and Capacity Usage`;
    setFileName(fileName);
  }, []);

  const filteredFields = customFilter.map((item) => ({
    name: item.name,
    capacityConsumption: item.capacityConsumption,
    numberOfdocs: item.numberOfdocs,
    willUploaded: item.willUploaded,
  }));

  const handleDownload = async (type) => {
    if (data) {
      let fileType = type.toLowerCase();
      let reportTitle = "Document and Capacity Usage Report";
      let fileName = `Document and Capacity Usage Report.${fileType}`;

      try {
        const result = await triggerDownload({
          reportTitle,
          data: filteredFields,
          type: fileType,
          firmId: firmId
        }).unwrap();
        const url = window.URL.createObjectURL(new Blob([result]));
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        toast.success(`Report downloaded successfully.`);
      } catch (error) {
        toast.error(
          error?.data?.message ||
            error?.message ||
            "Failed to download the file. Please try again."
        );
      }
    } else {
      toast.error("No data available for download.");
    }
  };


  return (
    <>
      <div
        className="px-3 px-lg-5 firm-reports-page-container"
        data-testid="document-capacity-reports-page"
      >
        <div className="firm-reports-second-div">
          <div className="d-flex justify-content-center justify-content-space-between gap-4 flex-wrap d-block d-lg-none">
            <Container>
              <Row className="justify-content-center">
                <Col className="p-3" lg={2} md={6} sm={12}>
                  <div
                    className={`pt-2 bg-grey firm-report-tiles-2 clickable-tile`}
                  >
                    <div className="px-2 firm-reports-tiles firm-titles-header">
                      {reportsPlaceholder.docsPerUser}
                    </div>
                    <div className="px-2 firm-titles-value">
                      {docPerUser || 0}
                    </div>
                  </div>
                </Col>
                <Col className="p-3" lg={2} md={6} sm={12}>
                  <div
                    className={`pt-2 bg-blue firm-report-tiles-2 clickable-tile`}
                  >
                    <div className="px-2 firm-reports-tiles firm-titles-header">
                      {reportsPlaceholder.willsUploaded}
                    </div>
                    <div className="px-2 firm-titles-value">
                      {willsUploaded ? `${willsUploaded}%` : "0%"}
                    </div>
                  </div>
                </Col>
                <Col className="p-3" lg={2} md={6} sm={12}>
                  <div
                    className={`pt-2 bg-red firm-report-tiles-2 clickable-tile`}
                  >
                    <div className="px-2 firm-reports-tiles firm-titles-header">
                      {reportsPlaceholder.greatThan90Per}
                    </div>
                    <div className="px-2 firm-titles-value">
                      {greaterThan90Percent ? `${greaterThan90Percent}%` : "0%"}
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="d-none d-lg-block">
            <div className="py-3 px-3 d-flex justify-content-center justify-content-space-between gap-4 flex-wrap">
              <div className={`pt-2 bg-grey firm-report-tiles-2`}>
                <div className="px-2 firm-reports-tiles firm-titles-header">
                  {reportsPlaceholder.docsPerUser}
                </div>
                <div className="px-2 firm-titles-value">{docPerUser || 0}</div>
              </div>
              <div className={`pt-2 bg-blue firm-report-tiles-2`}>
                <div className="px-2 firm-reports-tiles firm-titles-header">
                  {reportsPlaceholder.willsUploaded}
                </div>
                <div className="px-2 firm-titles-value">
                  {willsUploaded ? `${willsUploaded}%` : "0%"}
                </div>
              </div>
              <div className={`pt-2 bg-red firm-report-tiles-2`}>
                <div className="px-2 firm-reports-tiles firm-titles-header">
                  {reportsPlaceholder.greatThan90Per}
                </div>
                <div className="px-2 firm-titles-value">
                  {willsUploaded ? `${greaterThan90Percent}%` : "0%"}
                </div>
              </div>
            </div>
          </div>

          <div className="px-3 py-2 search-container d-block d-sm-none">
            <div className="search-icon">
              <AGSearchIcon />
            </div>
            <div className="search-input-field ">
              <input
                type="text"
                placeholder="Search"
                value={searchText}
                autoComplete="off"
                onChange={handleSearchChange}
                id="search-firm-input-field"
                data-testid="grid-search-input"
              />
            </div>
            {searchText && (
              <div
                onClick={handleClearSearch}
                className="clear-search-button-mb"
              >
                <SearchXIcon />
              </div>
            )}
          </div>

          <div className="firm-reports-second-div py-2">
            <div className="d-flex px-3 justify-content-between align-items-center">
              <div className="firm-reports-table-title d-flex"></div>
              <div className="d-flex gap-3">
                <div className="d-flex">
                  <div className="search-container d-none d-md-block">
                    <div className="search-icon">
                      <AGSearchIcon />
                    </div>
                    <div className="search-input-field flex-1">
                      <input
                        type="text"
                        placeholder="Search"
                        value={searchText}
                        autoComplete="off"
                        onChange={handleSearchChange}
                        id="search-firm-input-field"
                        data-testid="grid-search-input"
                      />
                    </div>
                    {searchText && (
                      <div
                        onClick={handleClearSearch}
                        className="clear-search-button"
                      >
                        <SearchXIcon />
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <div>
                    <Dropdown>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip className="tooltip">Download</Tooltip>
                        }
                      >
                        <Dropdown.Toggle
                          as="div"
                          className="ms-2 cursor-pointer"
                          data-testid="download"
                        >
                          <Download />
                        </Dropdown.Toggle>
                      </OverlayTrigger>
                      <Dropdown.Menu align="right">
                        <Dropdown.Item onClick={() => handleDownload("PDF")}>
                          {reportPlaceholder.downloadAsPDF}
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDownload("CSV")}>
                          {reportPlaceholder.downloadAsCSV}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip className="tooltip">Share</Tooltip>}
                    >
                      <div className="ms-3 cursor-pointer">
                        <Share onClick={handleShare} data-testid="share" />
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="py-2 px-3">
            <AgGrid
              quickFilterText={searchText}
              rowData={customFilter}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              getRowStyle={getRowStyle}
              paginationSizeLimit={paginationSizeLimit}
              rowSelection={"multiple"}
            />
            {(isLoading || download) && <Loader data-testid="loader" />}
          </div>
        </div>
      </div>
      <ShareReportModalPopup
        showModal={showModal}
        setShowCallback={() => setShowModal(false)}
        bodyData={[...headerRow,...filteredFields]}
        shareFileName={fileName}
      />
    </>
  );
}
